import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function SEO({
  title = 'Bådtransport | JT transportsejlads',
  description = 'Bådtransport i Mårslet, Aarhus, Horsens og omegn. Din bådtransportør på vandet.',
  ogTitle,
  ogDescription,
  ogImage = 'https://assets.auxodev.dk/assets/a8b5f246-9eaa-4cb1-adf9-4b882abefbbd/gettyimages-170088390.jpg',
  canonicalUrl
}) {
  const location = useLocation();

  useEffect(() => {
    // 1. Title
    const formattedTitle = title.includes('JT transportsejlads')
      ? title
      : `${title} - JT transportsejlads`;
    document.title = formattedTitle;

    // 2. Language
    document.documentElement.lang = 'da-DK';

    // 3. Helper to update/create meta tag
    const setMetaTag = (attrName, attrVal, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attrName}="${attrVal}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attrName, attrVal);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMetaTag('name', 'description', description);
    setMetaTag('property', 'og:title', ogTitle || formattedTitle);
    setMetaTag('property', 'og:description', ogDescription || description);
    setMetaTag('property', 'og:image', ogImage);
    setMetaTag('property', 'og:type', 'website');
    setMetaTag('name', 'twitter:card', 'summary_large_image');
    setMetaTag('name', 'twitter:title', ogTitle || formattedTitle);
    setMetaTag('name', 'twitter:description', ogDescription || description);
    setMetaTag('name', 'twitter:image', ogImage);

    // 4. Canonical link
    const currentUrl = canonicalUrl || `https://jttransportsejlads.dk${location.pathname === '/' ? '' : location.pathname}`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', currentUrl);
  }, [title, description, ogTitle, ogDescription, ogImage, canonicalUrl, location.pathname]);

  return null;
}
